<section id="splash">

</section>

<style>
    section#splash {
        /*height: 100%;*/
        /*width: 100%;*/
        text-align: center;
    }
</style>